import type { CategoriesViewProps } from '../../types';
import * as React from 'react';
import { CollectionsD as CollectionsComponent } from '../../containers/CollectionsD';

export function View(props: CategoriesViewProps) {
  return (
    <>
      <CollectionsComponent {...props} />
    </>
  );
}
